const style = document.createElement('style');

export default style;
